import React, { useState, useEffect } from 'react';
import { obtenerTerminales } from '../../services/mesasServicio';

const TerminalSelector = ({ onSeleccionar }) => {
    const [terminales, setTerminales] = useState([]);
    const [seleccionado, setSeleccionado] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        obtenerTerminales()
            .then(data => {
                const lista = Array.isArray(data) ? data : [];
                // Si hay 0 o 1 punto de venta, no tiene sentido preguntar
                if (lista.length === 0) {
                    onSeleccionar(''); // sin PDV configurado
                    return;
                }
                if (lista.length === 1) {
                    onSeleccionar(lista[0].nombre); // auto-selección silenciosa
                    return;
                }
                setTerminales(lista);
                setLoading(false);
            })
            .catch(() => {
                onSeleccionar(''); // si falla la API, continuar sin PDV
            });
    }, [onSeleccionar]);

    const confirmar = () => {
        if (!seleccionado) return;
        onSeleccionar(seleccionado.nombre);
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 99999, backgroundColor: '#f0f2f5',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            padding: '24px'
        }}>
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                <div style={{ fontSize: '1.15rem', fontWeight: '800', color: '#1a1c1d', letterSpacing: '-0.5px' }}>KOMITY</div>
                <div style={{ fontSize: '0.6rem', color: '#adb5bd', textTransform: 'uppercase', letterSpacing: '2px' }}>Configuración del equipo</div>
            </div>

            <div style={{
                background: 'white', borderRadius: '20px', padding: '28px 22px',
                maxWidth: '400px', width: '100%', boxShadow: '0 8px 32px rgba(0,0,0,0.10)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '22px' }}>
                    <div style={{
                        width: '48px', height: '48px', background: '#fff4ec', borderRadius: '13px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px'
                    }}>
                        <i className="fas fa-desktop" style={{ fontSize: '20px', color: '#f26b21' }}></i>
                    </div>
                    <h2 style={{ fontSize: '0.95rem', fontWeight: '700', color: '#1a1c1d', margin: '0 0 5px' }}>
                        ¿Desde qué punto de venta operas?
                    </h2>
                    <p style={{ fontSize: '0.73rem', color: '#6c757d', margin: 0, lineHeight: 1.5 }}>
                        Se guarda en este dispositivo.<br />Puedes cambiarlo desde el menú.
                    </p>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <div className="spinner-border spinner-border-sm text-secondary"></div>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '18px' }}>
                        {terminales.length === 0 && (
                            <p style={{ textAlign: 'center', color: '#adb5bd', fontSize: '0.8rem' }}>
                                Sin terminales configuradas — usa "Sin terminal"
                            </p>
                        )}
                        {terminales.map(t => {
                            const activo = seleccionado && seleccionado.id === t.id;
                            return (
                                <div
                                    key={t.id}
                                    onClick={() => setSeleccionado(t)}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '12px',
                                        padding: '12px 14px', borderRadius: '12px', cursor: 'pointer',
                                        border: activo ? '2px solid #f26b21' : '2px solid #e9ecef',
                                        background: activo ? '#fff8f4' : 'white',
                                        transition: 'all 0.12s'
                                    }}
                                >
                                    <div style={{
                                        width: '38px', height: '38px', borderRadius: '9px', flexShrink: 0,
                                        background: activo ? '#f26b21' : '#e9ecef',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <i className="fas fa-cash-register" style={{ fontSize: '15px', color: activo ? 'white' : '#6c757d' }}></i>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: '700', fontSize: '0.87rem', color: '#1a1c1d' }}>{t.nombre}</div>
                                        {t.descripcion && (
                                            <div style={{ fontSize: '0.72rem', color: '#6c757d', marginTop: '1px' }}>{t.descripcion}</div>
                                        )}
                                    </div>
                                    {activo && (
                                        <i className="fas fa-check" style={{ color: '#f26b21', fontSize: '14px' }}></i>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                <button
                    onClick={confirmar}
                    disabled={!seleccionado}
                    style={{
                        width: '100%', padding: '13px',
                        background: seleccionado ? '#1a1c1d' : '#dee2e6',
                        color: seleccionado ? 'white' : '#adb5bd',
                        border: 'none', borderRadius: '12px', fontSize: '0.87rem',
                        fontWeight: '700', cursor: seleccionado ? 'pointer' : 'default',
                        marginBottom: '8px', transition: 'all 0.12s'
                    }}
                >
                    {seleccionado ? `Confirmar — ${seleccionado.nombre}` : 'Selecciona un terminal'}
                </button>

                <button
                    onClick={() => onSeleccionar('')}
                    style={{
                        width: '100%', padding: '9px', background: 'transparent',
                        color: '#adb5bd', border: 'none', fontSize: '0.74rem', cursor: 'pointer'
                    }}
                >
                    Continuar sin punto de venta
                </button>
            </div>
        </div>
    );
};

export default TerminalSelector;
